import React, {useContext, useEffect, useState} from 'react';
import {connect} from 'react-redux';
import SimActivationContext from 'app/Components/Page/SimActivationPage/SimActivationContext';
import {requestActivate, getOrdersList} from '../SimActivationProviders';
import InnerLoader from 'app/Components/Shared/Loader/InnerLoader';
import classNames from 'classnames';
import PopUp from '../../../Shared/Popup/PopUp';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import BeforeContinuePopUp from '../popupComponent/BeforeContinuePopUp.js';
import {isMobile} from 'react-device-detect';
import {
  dwhPortingEsimPopupButtonClick,
  dwhPortingInfoPopupClick,
  dwhPortingPageButtonClick,
  dwhPortingPageDisplayed,
  dwhPortingTimeDefineDisplayed,
  dwhPortingTimeDelayDisplayed,
} from '../reports/dwhReports';

function portingSimTypeParam(isEsim: boolean | null | undefined) {
  return isEsim != null && isEsim === true ? 'eSIM' : 'SIM';
}

function SimActivateCountdown() {
  const [timer, setTimer] = useState(40);
  const [{phone, verification, ticket, activation, result: ordersResult}, dispatch] = useContext(SimActivationContext);

  useEffect(() => {
    if (activation !== 'Progress') return;
    const subscriberNumber = phone;
    const verificationCode = verification;
    const ticketId = ticket;
    let timer = 40;
    const timerId = setInterval(() => {
      timer--;
      if (timer < 0) clearInterval(timerId);
      else setTimer(timer);
    }, 1000);

    const retry = async () => {
      const listResult = await getOrdersList({subscriberNumber, ticketId, verificationCode});
      if (listResult?.time && listResult.status == 'IN_PROGRESS') {
        dispatch({type: 'activate-time', result: listResult});
        clearInterval(timerId);
      } else if (timer > 0) {
        setTimeout(retry, 5000);
      } else {
        dispatch({type: 'activate-timeout'});
      }
    };

    retry();
    return () => {
      clearInterval(timerId);
    };
  }, [activation]);

  return (
    <div className='activated'>
      <div className='timer'>{timer}</div>
    </div>
  );
}

function SimActivate(props) {
  const [isShowPopUp, setPopUp] = useState(true);
  let instructionAfterTimeForNiudEsimList = null;
  let instructionAfterDelayOfNiudEsimList = null;

  if (props.iContent?.esimData?.value != null) {
    instructionAfterTimeForNiudEsimList = props.iContent?.esimData?.expandedValue[0]?.instructionAfterTimeForNiudEsim?.value;
    instructionAfterDelayOfNiudEsimList = props.iContent?.esimData?.expandedValue[0]?.instructionAfterDelayOfNiudEsim?.value;
  }

  const instructionAfterTimeForNiudSimList = props.iContent?.instructionAfterTimeForNiudSim?.value;
  const instructionAfterDelayOfNiudSimList = props.iContent?.instructionAfterDelayOfNiudSim?.value;
  const [{phone, verification, ticket, result, activation}, dispatch] = useContext(SimActivationContext);
  const isActivated = activation == 'Progress' || activation == 'Activated';

  useEffect(() => {
    if (result != null && result != undefined) {
      if (result?.time) {
        dwhPortingTimeDefineDisplayed({
          subscriber: phone ?? '',
          param1: portingSimTypeParam(result?.isEsim),
          param2: result?.time,
          userDetails: props.userDetails,
        });
      } else {
        dwhPortingTimeDelayDisplayed({
          subscriber: phone ?? '',
          param1: portingSimTypeParam(result?.isEsim),
          userDetails: props.userDetails,
        });
      }
    }
  }, [result]);

  useEffect(() => {
    dwhPortingPageDisplayed({
      subscriber: phone ?? '',
      param1: portingSimTypeParam(result?.isEsim),
      userDetails: props.userDetails,
    });
  }, []);

  const onActivate = async () => {
    dwhPortingPageButtonClick({
      subscriber: phone ?? '',
      param1: portingSimTypeParam(result?.isEsim),
      userDetails: props.userDetails,
    });
    if (activation != 'Idle') return;
    const subscriberNumber = phone;
    const verificationCode = verification;
    const ticketId = ticket;
    dispatch({type: 'activate-start'});
    const status = await requestActivate({subscriberNumber, ticketId, verificationCode});
    dispatch({type: 'activate', status});
  };
  return (
    <div className='SimActivate'>
      <h1 className='SimActivationBlock__main__title'>הפעלת ניוד</h1>

      {!isActivated && !result?.isEsim && (
        <>
          <h1 className='SimActivationBlock__top__title'>שנתחיל בניוד ?</h1>
          <div style={{width: !isMobile ? '400px' : '300px', margin: 'auto', lineHeight: '1', marginBottom: '10px'}}>
            <div className='SimActivationBlock__top__link'>שימו לב לא להוציא עדיין את ה-SIM הישן</div>
          </div>
        </>
      )}

      {!isActivated && result?.isEsim && (
        <>
          <h1 className='SimActivationBlock__top__title'>שנתחיל בניוד ?</h1>
          <div style={{width: !isMobile ? '400px' : '300px', margin: 'auto', lineHeight: '1', marginBottom: '10px'}}>
            {/* <div className='SimActivationBlock__top__link'>שימו לב שהמכשיר מחובר ל-Wi-Fi</div> */}
            <div className='SimActivationBlock__top__link'>אין להוציא עדיין את ה-SIM הישן</div>
          </div>
        </>
      )}

      {isActivated && result?.isEsim && (
        <>
          <h1 className='SimActivationBlock__top__title'>הניוד בתהליך</h1>
          <div style={{width: !isMobile ? '400px' : '300px', margin: 'auto', lineHeight: '1', marginBottom: '10px'}}>
            {/* <div className='SimActivationBlock__top__link'>שימו לב שהמכשיר מחובר ל-Wi-Fi</div> */}
            <div style={{marginTop: '0'}} className='SimActivationBlock__top__link'>
              אין להוציא עדיין את ה-SIM הישן
            </div>
          </div>
        </>
      )}

      {isActivated && !result?.isEsim && (
        <>
          <h1 className='SimActivationBlock__top__title'>הניוד בתהליך</h1>
          <div style={{width: !isMobile ? '400px' : '300px', margin: 'auto', lineHeight: '1', marginBottom: '10px'}}>
            <div className='SimActivationBlock__top__link'>שימו לב לא להוציא עדיין את ה-SIM הישן</div>
          </div>
        </>
      )}

      <div className='SimActivate__sim'>
        <div className='SimActivate__sim__content'>
          {result?.isEsim ? (
            <>
              <div className={classNames('labelInProcess', {active: activation == 'Progress', activated: activation == 'Activated'})}>
                הקו המתנייד-<span className='numberInProcess'>{result?.subscriberNumber}</span>
              </div>
              {/* <div className='numberInProcess'>{result?.subscriberNumber}</div> */}
              <div
                className={classNames('update', {
                  active: activation === 'Activated' || activation === 'Idle' || activation == 'Activating',
                })}>
                כבר נעדכן אותך <br />
                בשעת הסיום{' '}
              </div>
            </>
          ) : (
            <>
              <div className='labelSim'>מספר ה-SIM:</div>
              <div className='code'>{result?.simNumber}</div>
              <div className='labelSim'>מספר הטלפון:</div>
              <div className='number'>{result?.subscriberNumber}</div>
            </>
          )}
          <div
            className={classNames('details state-idle', {active: activation == 'Idle', animate: activation == 'Activating'})}
            onClick={onActivate}>
            לחצו להפעלת ניוד
          </div>
          <div className={classNames('details state-activating', {active: activation == 'Activating'})}>
            <InnerLoader isOverlay={false} isLoading={activation == 'Activating'} />
          </div>
          <div className={classNames('details', {active: activation == 'Progress'})}>
            <SimActivateCountdown />
          </div>
          <div className={classNames('details state-end-date', {active: activation == 'Activated'})}>
            {result?.time ? (
              <>
                שעת סיום הניוד
                <br />
                {result?.time}
              </>
            ) : (
              <>יש עיכוב בקבלת שעת ניוד,נעדכן ב-SMS</>
            )}
          </div>

          {isActivated && result?.time ? (
            <>
              {/* <div className='spliter' /> */}
              {result?.isEsim ? (
                <div>
                  {instructionAfterTimeForNiudEsimList != null &&
                    instructionAfterTimeForNiudEsimList?.map((e: any, i: number) => {
                      return (
                        <div className='div-list-style'>
                          <div className='img-sign'></div>
                          <li key={i}>{e}</li>
                        </div>
                      );
                    })}
                </div>
              ) : (
                <div>
                  {instructionAfterTimeForNiudSimList &&
                    instructionAfterTimeForNiudSimList?.map((e: any, i: number) => {
                      return (
                        <div className='div-list-style'>
                          <div className='img-sign'></div>
                          <li key={i}>{e}</li>
                        </div>
                      );
                    })}
                </div>
              )}
            </>
          ) : null}

          {isActivated && !result?.time ? (
            <>
              {/* <div className='spliter' /> */}
              {result?.isEsim ? (
                <>
                  {instructionAfterDelayOfNiudEsimList != null &&
                    instructionAfterDelayOfNiudEsimList?.map((e: any, i: number) => {
                      return (
                        <>
                          <li key={i}>{e}</li>
                        </>
                      );
                    })}
                </>
              ) : (
                <>
                  {instructionAfterDelayOfNiudSimList &&
                    instructionAfterDelayOfNiudSimList?.map((e: any, i: number) => {
                      return (
                        <>
                          <li key={i}>{e}</li>
                        </>
                      );
                    })}
                </>
              )}
            </>
          ) : null}
        </div>
      </div>

      {/* {result?.time && result?.isEsim ? (
        <>
          <EsimInstallation esimData={props.iContent?.esimData} />
        </>
      ) : null} */}
      <PopUp preventWrapperClose={true} showPopUp={isShowPopUp} onClose={() => setPopUp(false)}>
        <BeforeContinuePopUp
          isEsim={result?.isEsim}
          iContent={props.iContent}
          isPopUp={true}
          subscriber={phone ?? ''}
          footerButton={
            <BtnSubmit
              onclick={() => {
                if (result?.isEsim != null && result?.isEsim === true) {
                  dwhPortingEsimPopupButtonClick({
                    subscriber: phone ?? '',
                    param1: 'eSim',
                    userDetails: props.userDetails,
                  });
                } else {
                  dwhPortingInfoPopupClick({
                    subscriber: phone ?? '',
                    param1: 'SIM',
                    userDetails: props.userDetails,
                  });
                }

                setPopUp(false);
              }}
              text='הבנתי, תודה'
            />
          }
        />
      </PopUp>
    </div>
  );
}

const mapStateToProps = (state) => ({
  userDetails: state.authentication?.loginData?.userDetails,
});

export default connect(mapStateToProps)(SimActivate);
